import { render, staticRenderFns } from "./AlocaPassageiroLinhaDialog.vue?vue&type=template&id=2309acd4&"
import script from "./AlocaPassageiroLinhaDialog.vue?vue&type=script&lang=js&"
export * from "./AlocaPassageiroLinhaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports